import * as actions from './actions';
import * as reducers from './reducers';
import * as selectors from './selectors';

const text = { selectors, actions, reducers };
export default text;
